module.exports = __webpack_public_path__ + "static/images/panelBuilder/drag-n-drop.svg";